import { CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO } from "api/DTOs/ConciliacionConciliarMovimientosCommandDto"
import { EntidadConciliableReadingDtoProps } from "api/DTOs/EntidadConciliableReadingDto"
import { GetFlujosConciliablesDtoProps } from "api/DTOs/GetFlujosConciliablesDto"
import {
  devolucionesConciliablesCall,
  getDevolucionesConciliables,
} from "api/Devolucion.service"
import {
  facturasConciliablesCall,
  getFacturasConciliables,
} from "api/Factura.service"
import {
  flujoTesoreriaConciliablesCall,
  getFlujoTesoreriaConciliables,
} from "api/FlujoTesoreria.service"
import {
  getPrestamosConciliables,
  prestamosConciliablesCall,
} from "api/Prestamos.service"
import { GetFacturasConciliablesDtoProps } from "api/Schemas/GetFacturasConciliablesDtoProps"
import { ESTADO_CONCILIACION } from "api/Types/EstadoConciliacion"
import { TIPO_DOCUMENTO_COMERCIAL } from "api/Types/TipoDocumentoComercial"
import { TIPO_FLUJO_TESORERIA } from "api/Types/TipoFlujoTesoreria"
import { TFunction } from "i18next"
import { TablaConciliarMovimientosDataProps } from "../hooks/useManualRowSelection"
import { SelectedDocumentsProps } from "../layout/ColumnRight"

export const getEstadoLabels = (t: TFunction): { [key: number]: string } => {
  return {
    [ESTADO_CONCILIACION.SIN_CONCILIAR]: t(
      "nsAssets.filters.status.sinConciliar"
    ),
    [ESTADO_CONCILIACION.CONCILIADO]: t("nsAssets.filters.status.conciliado"),
  }
}

export const INITIAL_ESTADOS_CONCILIAR = {
  [ESTADO_CONCILIACION.SIN_CONCILIAR]: true,
  [ESTADO_CONCILIACION.CONCILIADO]: false,
}

export const RESET_ESTADOS_CONCILIAR = {
  [ESTADO_CONCILIACION.SIN_CONCILIAR]: false,
  [ESTADO_CONCILIACION.CONCILIADO]: false,
}

export const TAB = {
  PAGOS_COBROS: {
    KEY: CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO.FLUJO_TESORERIA_IDS,
    TYPE: ["", "Cobro", "Pago"],
    LABEL: "bancos.conciliacion.modal.headerAccounting",
    SERVICE: getFlujoTesoreriaConciliables,
    CANCEL_TOKEN: flujoTesoreriaConciliablesCall,
  },
  FACTURAS: {
    KEY: CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO.FACTURA_IDS,
    TYPE: ["Compra", "Venta"],
    LABEL: "bancos.conciliacion.modal.headerInvoce",
    SERVICE: getFacturasConciliables,
    CANCEL_TOKEN: facturasConciliablesCall,
  },
  DEVOLUCIONES: {
    KEY: CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO.DEVOLUCION_IDS,
    TYPE: null,
    LABEL: "bancos.conciliacion.modal.headerDev",
    SERVICE: getDevolucionesConciliables,
    CANCEL_TOKEN: devolucionesConciliablesCall,
  },
  PRESTAMOS: {
    KEY: CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO.AMORTIZACION_IDS,
    TYPE: null,
    LABEL: "bancos.conciliacion.modal.headerLoan",
    SERVICE: getPrestamosConciliables,
    CANCEL_TOKEN: prestamosConciliablesCall,
  },
} as const

export interface TabItem {
  KEY: (typeof TAB)[keyof typeof TAB]["KEY"]
  TYPE: (typeof TAB)[keyof typeof TAB]["TYPE"]
  LABEL: (typeof TAB)[keyof typeof TAB]["LABEL"]
  SERVICE: (typeof TAB)[keyof typeof TAB]["SERVICE"]
  CANCEL_TOKEN?: (typeof TAB)[keyof typeof TAB]["CANCEL_TOKEN"]
}

export const calculateImporteContable = (
  movimientoContable: SelectedDocumentsProps
) => {
  const amount = Number(movimientoContable?.importe ?? 0)
  if (movimientoContable.tabKey === TAB.FACTURAS.KEY) {
    const isCompra =
      movimientoContable?.tipo === TIPO_DOCUMENTO_COMERCIAL.COMPRA
    const isAbonoVenta =
      movimientoContable?.tipo === TIPO_DOCUMENTO_COMERCIAL.VENTA && amount < 0
    const isAbonoCompra =
      movimientoContable?.tipo === TIPO_DOCUMENTO_COMERCIAL.COMPRA && amount < 0
    if (isAbonoVenta) {
      return amount
    }
    if (isAbonoCompra || isCompra) {
      return -amount
    }
    return amount
  }

  if (movimientoContable.tabKey === TAB.PAGOS_COBROS.KEY) {
    const isPago = movimientoContable?.tipo === TIPO_FLUJO_TESORERIA.PAGO
    const isAbonoPago =
      movimientoContable?.tipo === TIPO_FLUJO_TESORERIA.PAGO && amount < 0
    const isAbonoCobro =
      movimientoContable?.tipo === TIPO_FLUJO_TESORERIA.COBRO && amount < 0
    if (isAbonoCobro) {
      return amount
    }
    if (isAbonoPago || isPago) {
      return -amount
    }
    return amount
  }

  return amount
}

export const calculateImportePendiente = (
  leftSelectedData?: Array<TablaConciliarMovimientosDataProps> | null,
  rigthSelectedData?: Array<
    | EntidadConciliableReadingDtoProps
    | GetFacturasConciliablesDtoProps
    | GetFlujosConciliablesDtoProps
  >
) => {
  const importeLeft =
    leftSelectedData?.reduce(
      (total: $TSMigrationFixMe, movimiento: $TSMigrationFixMe) =>
        total + (movimiento?.importe ?? 0),
      0
    ) || 0

  const importeRight =
    rigthSelectedData?.reduce((total, movimiento) => {
      const importe = movimiento.importe ?? 0
      const tipo = movimiento?.tipo

      if (
        tipo === TIPO_FLUJO_TESORERIA.PAGO ||
        tipo === TIPO_DOCUMENTO_COMERCIAL.COMPRA
      ) {
        return total - importe
      }
      return total + importe
    }, 0) ?? 0

  return importeLeft - importeRight
}
